module.exports = __webpack_public_path__ + "static/media/glory-stance.18dfade2.png";